export default __webpack_public_path__ + "static/media/HeroStar.4555974f.svg";